import Backbone from 'backbone'
import _ from 'lodash'
import formHelper from 'scoreboard/components/form-helper'
import WsConstants from 'scoreboard/admin/model/ws-constants'
const { WS_VENDOR_TYPE } = WsConstants
import constants from 'scoreboard/components/constants'
const {POST} = constants
import $ from 'jquery'
import {createAnchor} from 'scoreboard/components/urls-to-links'
import i18n from 'scoreboard/components/i18n'
import template
	from 'scoreboard/admin/connections/rest/vendor-specific/oracle-netsuite-metadata.hbs'
import highlight from 'scoreboard/components/highlight'

const OracleNetSuiteMetadata = Backbone.View.extend({

	tagName: 'form',

	className: 'vendor-specific-metadata',

	/**
	 * @param [options.$parent] {jQuery} the element to append this view to
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		const $parent = this.options.$parent
		this.$el.append(template())

		const attrs = this.model.attributes
		if (attrs.wsVendorType !== WS_VENDOR_TYPE.ORACLE_NETSUITE) return

		// don't display all the regular http form stuff that the user doesn't need to modify
		$parent.find('.oauth-paragraph').addClass('is-not-displayed')
		$parent.find('[name=wsAuthenticationType]').val(POST)
		$parent.find('.authentication-type').addClass('is-not-displayed')
		$parent.find('.http-method').addClass('is-not-displayed')
		$parent.find('.url-parameters').addClass('is-not-displayed')
		$parent.find('.http-headers').addClass('is-not-displayed')
		$parent.find('.request-body').addClass('is-not-displayed')

		const banner = $parent.find('.banner')

		banner.append(`
			<div class="oracle-netsuite-paragraph">
				${i18n.get('admin.importConnections.web-service.rest.vendor.oracleNetsuite.firstStep')}
			</div>
		`)

		const requiredFieldsList = $('<ul>')
		banner.append(requiredFieldsList)

		this.createRequiredFieldBulletPoint(requiredFieldsList,
			'admin.importConnections.web-service.oauthV2.accessTokenEndpoint',
			'admin.importConnections.web-service.oauthV2.accessTokenEndpoint.oracleNetSuite.explanation')
		this.createRequiredFieldBulletPoint(requiredFieldsList,
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.certificateId',
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.certificateId.explanation')
		this.createRequiredFieldBulletPoint(requiredFieldsList,
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.clientId',
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.clientId.explanation')
		this.createRequiredFieldBulletPoint(requiredFieldsList,
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.privateKey',
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.privateKey.explanation')

		const createIntegrationRecordsLink = createAnchor(
			'https://docs.oracle.com/en/cloud/saas/netsuite/ns-online-help/section_157771733782.html',
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.createIntegrationRecordsForOAuth2')
		const clientCredentialsSetupLink = createAnchor(
			'https://docs.oracle.com/en/cloud/saas/netsuite/ns-online-help/section_162686838198.html',
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.oauth2ClientCredentialsSetup')
		banner.append(`
			<div class="oracle-netsuite-paragraph">
				${i18n.get(
			'admin.importConnections.web-service.rest.vendor.oracleNetsuite.documentationLinks',
			createIntegrationRecordsLink, clientCredentialsSetupLink)}
			</div>
		`)

		formHelper.writeToDom(this.model, this.el)

		$parent.find('.vendor-specific-metadata').replaceWith(this.el)

		return this
	},

	createRequiredFieldBulletPoint: function(fieldsListEl$, fieldNameKey, explanationKey) {
		const bulletPoint = $('<li>')
		fieldsListEl$.append(bulletPoint)
		const fieldName = highlight(i18n.get(fieldNameKey))
		const explanation = i18n.get(explanationKey)
		bulletPoint.append(fieldName, ' ',  explanation)
	},

	saveState: function() {
		const attrs = this.model.attributes
		const fromDom = formHelper.readFromDom(this.el)

		_.extend(attrs, fromDom)
	},
})

export default OracleNetSuiteMetadata
OracleNetSuiteMetadata.__filename__ = 'admin/connections/rest/vendor-specific/oracle-netsuite-metadata.js'
